import { useQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import { PacketGraphDetailSchema } from "../types";

export function useCalculationGraph(
  orgCategory: string,
  orgId: string,
  batchId: string,
  packetId: string
) {
  return useQuery({
    queryKey: [
      "calculationGraph",
      orgCategory,
      orgId,
      batchId,
      packetId,
    ],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get(
        `/api/v1/shadow/batches/${orgCategory}/${orgId}/${batchId}/packets/${packetId}/graph`
      );
      return PacketGraphDetailSchema.parse(data);
    },
    enabled: !!orgCategory && !!orgId && !!batchId && !!packetId,
  });
}
